<template>
  <div>
    <auth-title label="Wir möchten Sie kennenlernen" />

    <auth-text>
      <p>
        Mit Ihrer E-Mail-Adresse legen wir Ihnen einen Account an, mit dem Sie sich bei unseren digitalen Angeboten anmelden können.
      </p>
    </auth-text>

    <auth-step-switcher label="Sie haben bereits einen Account? <u>Melden Sie sich an.</u>" @click="$emit('update', 'currentStep', 'login')" />

    <auth-salutation v-model="value.salutation" :error="error.salutation" @input="updateValue" />

    <auth-group>
      <auth-input style="width: 15em" type="text" name="lastname" label="Name" v-model="value.lastname" :error="error.lastname" @input="updateValue" />

      <auth-input style="width: 15em" type="text" name="firstname" label="Vorname" v-model="value.firstname" :error="error.firstname" @input="updateValue"/>
    </auth-group>

    <auth-group>
      <auth-input style="width: 15em" type="email" name="username" label="E-Mail-Adresse" v-model="value.username" :error="error.username" @input="updateValue"/>

      <auth-input style="width: 15em" type="password" name="password" label="Passwort (mindestens 8 Zeichen)" v-model="value.password" :error="error.password" @input="updateValue"/>
    </auth-group>

    <auth-agb-privacy-info :agbUrl="agbUrl" :privacyUrl="privacyUrl" />

    <auth-captcha :state="state" @update="update" />

    <auth-group>
      <auth-button
        v-if="onPrev"
        label="ZURÜCK"
        @click="() => onPrev()"
        is-prev-button
      />
      <auth-button
        v-if="state.currentStep === 'registration'"
        label="WEITER"
        @click="submit"
      />
    </auth-group>
  </div>
</template>

<script>
import Api from "../api/api";
import Validator, { emailRegex } from "./validator";
import AuthTitle from "@/components/plenigo-auth-v2/components/auth-title";
import AuthStepSwitcher from "@/components/plenigo-auth-v2/components/auth-step-switcher";
import AuthSalutation from "@/components/plenigo-auth-v2/components/auth-salutation";
import AuthInput from "@/components/plenigo-auth-v2/components/auth-input";
import AuthAgbPrivacyInfo from "@/components/plenigo-auth-v2/components/auth-agb-privacy-info";
import AuthCaptcha from "@/components/plenigo-auth-v2/components/auth-captcha";
import AuthButton from "@/components/plenigo-auth-v2/components/auth-button";
import AuthGroup from "@/components/plenigo-auth-v2/components/auth-group";
import AuthText from "@/components/plenigo-auth-v2/components/auth-text";
import helper from "../helper/helper";

export default {
  props: {
    state: Object,
    agbUrl: String,
    privacyUrl: String,
    registrationReturnUrl: String,
    submitOnNext: String,
    onPrev: Function
  },
  components: { AuthGroup, AuthText, AuthButton, AuthCaptcha, AuthAgbPrivacyInfo, AuthInput, AuthSalutation, AuthStepSwitcher, AuthTitle },
  data() {
    return {
      value: {
        firstname: this.state.value && this.state.value.firstname,
        lastname: this.state.value && this.state.value.lastname,
        username: this.state.value && this.state.value.username,
        password: this.state.value && this.state.value.password,
        salutation: this.state.value && this.state.value.salutation
      },
      error: {
        firstname: false,
        lastname: false,
        username: false,
        password: false,
        salutation: false
      }
    };
  },
  methods: {
    update(property, value) {
      this.$emit("update", property, value);
    },
    async submit() {
      this.update("errorMessage", undefined);
      if (
        !Validator.validate(
          {
            firstname: /^\S+$/,
            lastname: /^\S+$/,
            username: emailRegex,
            password: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
            salutation: /^(Frau|Herr)$/
          },
          this.value,
          this.error
        )
      ) {
        return;
      }

      const registration = await Api.registration({
        ...this.value,
        optin_privacy: true,
        returnUrl: this.registrationReturnUrl
      });

      if (!registration.success) {
        let err = registration.message;
        if (err === "Diese E-Mailadresse ist bereits in Verwendung") {
          err += "<br/>" + "Bitte melden Sie sich mit der E-Mail Adresse an";
        }
        
        this.update("errorMessage", err);
        return;
      }

      helper.firstConfirm();
      this.updateValue();

      if (this.submitOnNext) {
        document.forms[this.submitOnNext].submit();
      } else {
        this.update("currentStep", "confirm");
      }
    },
    updateValue() {
      this.update("value", this.value);
    }
  }
};
</script>
